import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {ChatStore} from "@services/store";
import {AiChatFacade} from '../../ai-chat.facade';

/**
 * Renders next-step suggestions from the AI response.
 *
 * Displayed inline at the bottom of the message list when suggestions are available.
 * Clicking a suggestion sets it as the draft for the user to review before sending.
 */
@Component({
  selector: 'app-chat-suggestions',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './chat-suggestions.component.html',
  styleUrl: './chat-suggestions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatSuggestionsComponent {
  private readonly chatStore = inject(ChatStore);
  private readonly facade = inject(AiChatFacade);

  /**
   * Suggestions from the latest AI response.
   *
   * Populated by the backend's `summary.nextSteps`.
   * If empty, the component renders nothing.
   */
  suggestions = computed(() => this.chatStore.summary()?.nextSteps);

  hasSuggestions = computed(() => this.suggestions()?.length > 0);

  /**
   * Sets the clicked suggestion as the draft via facade.
   */
  protected selectSuggestion(s: string) {
    this.facade.useSuggestion(s);
  }
}
